/**
 * Prevents duplicate email capture sends to Make.com within a short time.
 * Uses localStorage so the same user can't trigger 2x in a row (double submit, two forms, etc.).
 */

const STORAGE_KEY = 'gv_email_capture_last';
const GLOBAL_COOLDOWN_MS = 30 * 1000;       // 30 sec: no second send at all (double-click)
const SAME_EMAIL_COOLDOWN_MS = 24 * 60 * 60 * 1000; // 24h: same email not sent again

function normalizeEmail(email) {
  return (email || '').trim().toLowerCase();
}

/**
 * Returns true if we are allowed to send this email to Make.com.
 * False if we recently sent (any email) or already sent this email in the last 24h.
 */
export function canSendEmailCapture(email) {
  if (typeof window === 'undefined' || !window.localStorage) return true;
  const normalized = normalizeEmail(email);
  if (!normalized) return false;

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return true;
    const { email: lastEmail, ts } = JSON.parse(raw);
    const now = Date.now();
    if (now - ts < GLOBAL_COOLDOWN_MS) return false;
    if (normalizeEmail(lastEmail) === normalized && now - ts < SAME_EMAIL_COOLDOWN_MS) return false;
    return true;
  } catch {
    return true;
  }
}

/**
 * Call after successfully sending email capture to Make.com.
 */
export function markEmailCaptureSent(email) {
  if (typeof window === 'undefined' || !window.localStorage) return;
  const normalized = normalizeEmail(email);
  if (!normalized) return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
      email: normalized,
      ts: Date.now()
    }));
  } catch (_) {}
}
